import React from 'react';
import { MDBContainer, MDBCard, MDBCardBody, MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ErrorFallback = ({ error, onBack, onRetry }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <MDBContainer className="mt-5">
      <MDBCard className="border-danger">
        <MDBCardBody>
          <div className="text-center">
            <MDBIcon
              fas
              icon="exclamation-triangle"
              size="3x"
              className="text-danger mb-3"
            />
            <h3 className="mb-3">{t("An error occurred")}</h3>
            <p className="mb-4">
              {t("The data could not be loaded. Please try again.")}
              <br />
              {t("The error has been automatically reported to our support team.")}
            </p>

            {error && (
              <div className="mb-4">
                <details className="text-start">
                  <summary className="cursor-pointer text-muted">
                    {t("Show technical details")}
                  </summary>
                  <div className="mt-3 p-3 bg-light rounded">
                    <p className="mb-2">
                      <strong>{t("Error")}:</strong> {error.toString()}
                    </p>
                  </div>
                </details>
              </div>
            )}

            <div className="d-flex justify-content-center gap-3">
              <MDBBtn color="secondary" outline onClick={onBack ?? (() => navigate(-1))}>
                <MDBIcon fas icon="arrow-left" className="me-2" />
                {t("Back")}
              </MDBBtn>
              <MDBBtn color="primary" onClick={onRetry ?? (() => window.location.reload())}>
                <MDBIcon fas icon="sync" className="me-2" />
                {t("Retry")}
              </MDBBtn>
            </div>
          </div>
        </MDBCardBody>
      </MDBCard>
    </MDBContainer>
  );
};

export default ErrorFallback;
